import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const Envelope: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.49854 6.49951L7.44966 7.70244C8.09348 8.09937 8.90609 8.09937 9.54991 7.70244L11.501 6.49951"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="2.49756"
      y="3.33154"
      width="12.005"
      height="9.33722"
      rx="3"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
